import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from "@angular/core";
import { MaterialModule } from "src/app/material.module";
import { HomepageApiService } from "./services/homepage-api-service";
import { DirectivesModule } from "../directives/module";
import { AppRoutingModule } from "src/app/app-routing.module";
import { HomepageAdd } from "../role/admin/components/homepage/modals/add/component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { HomepageHeroImageAdd } from "./components/homepage-hero-image/add/component";

@NgModule({
    imports: [CommonModule, MaterialModule, DirectivesModule, AppRoutingModule, DragDropModule],
    declarations: [HomepageAdd, HomepageHeroImageAdd],
    providers: [HomepageApiService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    exports: []
})

export class HomepageModule {}